// extracted by mini-css-extract-plugin
module.exports = {"row":"app_row__2rhnA","col":"app_col__3AV1t","container":"app_container__3ZgJL","flexGrow0":"app_flexGrow0__2_so_","flexGrow1":"app_flexGrow1__BqaPI"};